<div class="container">

  <div class="row">
    <h2 class="col-12 text-center">
      You've selected <b>{{ theTeams.length > 0 ? theTeams.length : '' }} teams</b>!
    </h2>
    <div class="col text-center">
      <button *ngIf="game.playing" (click)="clearTeams()" class="btn btn-warning btn-sm">
        Start over
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/>
          <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/>
        </svg>
      </button>
    </div>
  </div>

  <div class="{{ game.playing ? 'd-none' : 'row' }}">
    <div class="mb-3">
      <label for="howManyTeams" class="form-label col-12">
        How many teams will be playing?
      </label>
      <div class="btn-group col-12" role="group" aria-label="Basic example">
        <button (click)="howManyTeams($event, 2)" class="btn btn-primary">
          2<br><small>(4 pers)</small>
        </button>
        <button (click)="howManyTeams($event, 3)" class="btn btn-primary">
          3<br><small>(6 pers)</small>
        </button>
        <button (click)="howManyTeams($event, 4)" class="btn btn-primary">
          4<br><small>(8 pers)</small>
        </button>
      </div>
      <select id="howManyTeams" class="d-none form-select" aria-label="Default select example">
        <option selected>Select how many teams</option>
        <option value="2">2 (4 pers)</option>
        <option value="3">3 (6 pers)</option>
        <option value="4">4 (8 pers)</option>
      </select>
    </div>
  </div>

  <hr>

  <div *ngIf="!game.playing" class="row">
    <div *ngFor="let team of theTeams" class="col-12">
      <h3>
        {{ team.name }}
      </h3>
      <div class="mb-3">
        <label for='{{ "teamName" + team.id }}' class="form-label">Team {{ team.id + 1 }}</label>
        <input (blur)="saveName(team, $event)" value="{{ team.name }}" type="name" class="form-control" id='{{ "teamName" + team.id }}' placeholder="Team name">
      </div>
      <hr>
    </div>
  </div>
  <div *ngIf="game.playing">
    <h4>Round {{ game.round }}</h4>
    <div class="col" *ngFor="let team of theTeams">
      <div class="mb-3">
        <label for='{{ "bet" + team.id }}' class="form-label">{{ team.name ? team.name : ('Team ' + (team.id + 1)) }}'s bet</label>
        <input (keyup)="putBet(team, $event)" value="{{ team.bet }}" type="number" class="form-control" id='{{ "bet" + team.id }}' placeholder="Bet (0-15)">
      </div>
    </div>
    {{ game.playing }}
    <button (click)="startGame()" *ngIf="!game.playing" class="btn btn-success">Play</button>
    <button (click)="placeBets()" *ngIf="!game.bettingDone && game.playing" class="btn btn-success">Place bets</button>
    <button (click)="setResult()" *ngIf="game.bettingDone && game.playing" class="btn btn-success">Set results and start next round</button>
    <div class="col-12 list-group">
      <div class="row">
        <div class="list-group-item" style="background-color: transparent; color: #fff;" *ngFor="let team of theTeams">
          {{ team.name }}
          <div class="row" *ngFor="let round of team.rounds">
            <div class="col">
              <small>Round:</small> {{ round.numb }}
            </div>
            <div class="col">
              <small>Bet:</small> {{ round.bet }}
            </div>
            <div class="col">
              <small>Sets:</small> {{ round.bet }}
            </div>
            <div class="col">
              <small>Score:</small> {{ round.score }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
